import { BaseAPI } from '../BaseApi';
import { IUnderwriterResponse } from 'types/underwriter/IUnderwriterResponse';
import { eAPITags } from '../eAPITags';

export const UnderwritersAPI = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listUnderwriters: build.query<IUnderwriterResponse[], void>({
      query: () => `/timber/api/internal/underwriters`,
      providesTags: (result, error, request) => [{ type: eAPITags.Underwriters }],
    }),
  }),
  overrideExisting: false,
});

export const { useListUnderwritersQuery } = UnderwritersAPI;
